module.exports = require("plugin-pressuretests/shared/components/lotfit/Table");